import React from "react"
import Text, { H2Text } from "src/components/text/text.component"
import SkeletonLoading from "src/components/skeleton-loading"
import theme from "src/theme/"

import { ListingItems, ListingItem, ListingItemImage, StyledLink } from "src/containers/home/UI"
import { DEFAULT_SPACE_PICTURE } from "../../config/constants"
import MultiCarousel from "src/components/carousel"
import { BolgListType } from "."
import { RecommendedContainer } from "./recommend-listing"
import { BlogDateTime, ClientDetail, ClientImageSection, ClientName } from "./UI"
import Avatar from "src/components/avatar"
import { timeStampTo_M_Day } from "src/dashboards/components/stamptime-converter"
import { removeExtraUrlSymbols } from "src/utils/comman-methods"

interface Props {
  loading: boolean
  moreBlogs: BolgListType[]
  isTabletOrMobile: boolean
}
const MobileViewBlogs = (props: Props) => {
  const { loading, moreBlogs = [], isTabletOrMobile } = props

  return (
    <RecommendedContainer padding={"0"}>
      <H2Text color={theme.colors.black} fontWeight={600} fontSize={[4, 5, 5]}>
        More Blogs
      </H2Text>

      {!loading ? (
        <ListingItems justifyContent="center">
          <MultiCarousel infinite={false}>
            {moreBlogs.map((blog, index) => {
              if (!blog) return null
              else {
                return (
                  <>
                    <ListingItem
                      width={["100%"]}
                      key={`recommended-blog-${index}`}
                      marginBottom={0}
                    >
                      <StyledLink href={`/blog/${blog.id}/${removeExtraUrlSymbols(blog?.title)}`}>
                        <ListingItemImage
                          src={blog.thumbnailUrl}
                          placeholder={DEFAULT_SPACE_PICTURE}
                          transition="all 1s linear"
                        />

                        <Text mt={3}>
                          <ClientDetail>
                            <ClientImageSection>
                              <Avatar size="blog" imageURL={blog.user?.avatarUrl} />
                            </ClientImageSection>
                            <ClientName>
                              {blog!.user?.firstName!}&nbsp; {blog!.user?.lastName}
                              &nbsp;&nbsp;
                            </ClientName>
                            <BlogDateTime>{timeStampTo_M_Day(blog?.createdAt)}</BlogDateTime>
                          </ClientDetail>
                        </Text>

                        <Text
                          style={{
                            width: "100%",
                            marginTop: "10px"
                          }}
                          color={theme.colors.black}
                          fontSize={[1, 2, 2]}
                        >
                          {blog.title}
                        </Text>
                      </StyledLink>
                    </ListingItem>
                  </>
                )
              }
            })}
          </MultiCarousel>
        </ListingItems>
      ) : (
        [...Array(1)].map(() => (
          <SkeletonLoading
            rows={3}
            imgHeight={"100px"}
            width={isTabletOrMobile ? "100%" : "18rem"}
            isImage
          />
        ))
      )}
    </RecommendedContainer>
  )
}
export default MobileViewBlogs
